import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { map, of, switchMap } from 'rxjs';
import { CareType } from '@models/common/care-type.model';
import { IMigFormService } from '../services/mig-form.service';
import { User } from '@models/account/user.model';
import { catchError } from 'rxjs/operators';
import { notfound } from '@functions/routing';

@Injectable({
  providedIn: 'root',
})
export class MigResidentGuard implements CanActivate {
  module = inject(IMigFormService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const resident = route.params.resident;
    return this.module.api.get<User>(`users/get-by-id/${resident}`).pipe(
      switchMap(resident => {
        if (resident) {
          this.module.user$.next(resident);
          const community =
            resident.communities.find(x => x.id == resident.communityId) ??
            null;
          if (
            !this.module.corporation$.value &&
            community &&
            community.corporation
          ) {
            this.module.corporation$.next(community?.corporation);
          }
          this.module.community$.next(community);
          return this.module.api.get<CareType[]>(
            `communities/${resident.communityId}/care-types`
          );
        } else {
          this.router.navigate(['/']).then();
          return of(false);
        }
      }),
      map(caretypes => {
        if (Array.isArray(caretypes)) {
          this.module.careTypes$.next(caretypes);
        }
        return true;
      }),
      catchError(error => {
        this.router.navigate(['/']).then();
        return of(false);
      })
    );
    return true;
  }
}
